module.exports = __webpack_public_path__ + "static/media/ICON_FREE_TRIAL.0d798165.svg";